export const CATEGORY_TYPE = {
    RECENTLY: 'recentlyplayed',
    FAVORITES: 'favorites',
    PINNED: 'pinned',
    TAB: 'tab'
};
